import { SwitchAction } from '@infodata-group/inf-commons';

/**
 * @Deprecated Use `SwitchActionBuilder` from @infodata-group/inf-commons instead.
 */
export class SwitchActionBuilder<T> {
  private readonly _action: SwitchAction<T>;
  constructor(name: string, icon: string) {
    this._action = new SwitchAction<T>(name, icon, '');
  }

  public setTooltip(tooltip: string): SwitchActionBuilder<T> {
    this._action.tooltip = tooltip;
    return this;
  }

  public setIsActive(isActive: boolean): SwitchActionBuilder<T> {
    this._action.isActive = isActive;
    return this;
  }

  public setAlign(align: 'left' | 'center' | 'right'): SwitchActionBuilder<T> {
    this._action.align = align;
    return this;
  }

  public build(): SwitchAction<T> {
    return this._action;
  }
}
